import { render, staticRenderFns } from "./add-personal-user-account.vue?vue&type=template&id=5a6da022&scoped=true"
import script from "./add-personal-user-account.vue?vue&type=script&lang=js"
export * from "./add-personal-user-account.vue?vue&type=script&lang=js"
import style0 from "./add-personal-user-account.vue?vue&type=style&index=0&id=5a6da022&prod&lang=css"
import style1 from "./add-personal-user-account.vue?vue&type=style&index=1&id=5a6da022&prod&lang=css&scoped=true"
import style2 from "./add-personal-user-account.vue?vue&type=style&index=2&id=5a6da022&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6da022",
  null
  
)

export default component.exports